import BnSnDhanStocksPage from "./bnsndhanstockspage";

export default function SnDhanStocks() {
  return (
    <BnSnDhanStocksPage
      desk="sn"
      title="DHAN SENSEX STOCKS MARKET REACTION"
      gridTitle="Live Dhan Sensex Weightage Grid"
      activeTab="sensex"
    />
  );
}
